import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "normalize.css";
import store from "./store";
import HiUI from "@hi/ui";
import HiUIPlus from "@hi/ui-plus";
import "@hi/ui-plus/dist/hi-ui-plus.css";
// import '@hi/ui/dist/theme-blue-tech/index.css'
import i18n from "./locale";
import Locale from "@hi/ui/dist/locale";
import mixin from "@/mixins/global.js";

import "@/assets/css/hi-ui-theme.scss";
import "@/assets/css/index.scss";
import "./svg-symbol-icon.js";
import constant from "@/utils/constant.js";

import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

import { stylePro, byteLimit } from "./utils/directives";

//import { datafluxRum } from '@cloudcare/browser-rum';

Vue.mixin(mixin);

Vue.directive("style-pro", stylePro);
Vue.directive("byte-limit", byteLimit);

Vue.config.productionTip = false;

Vue.use(HiUI, {
  i18n: Locale.i18n((key, value) => i18n.t(key, value)),
  analyzable: false,
});

Vue.use(HiUIPlus, {
  analyzable: false,
});

Vue.prototype.$constant = constant;

// Sentry代码
if (process.env.VUE_APP_BASE_ENV === "chnPrd") {
  const ignoreList = [
    "chunk",
    "chrome-extension",
    "ResizeObserver loop",
    "Unexpected token '<'",
  ];
  Sentry.init({
    Vue,
    dsn: "https://4df25d77d4854f39a3ab5720b03dcb0e@sentry.hikvision.com/609",
    denyUrls: [
      /@hi\/ui\/es\/.*/, // 匹配 ES 模块路径
      /@hi\/ui\/lib\/.*/, // 匹配 lib 路径
      /chunk-.*@hi\/ui.*\.js/, // 匹配动态 chunk
    ],
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ["localhost", "hikme.hikvision.com"],
      }),
    ],
    environment: process.env.NODE_ENV,
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    beforeSend(event, hint) {
      const error = hint.originalException;
      if (
        ignoreList.some(
          (i) => error && error.message && error.message.includes(i)
        )
      ) {
        return null;
      }
      return event;
    },
  });
}

// 观测云
// if (process.env.NODE_ENV === 'production' && process.env.VUE_APP_BASE_API !== 'intl') {
//   if (process.env.VUE_APP_BASE_ENV !== 'chnPrd') {
//     // 测试环境
//     datafluxRum.init({
//       applicationId: 'hikme_tst',
//       site: 'https://test-rum-dataway.hikvision.com',
//       clientToken: 'ce3b2c8476c54970af3e47ba445048d0',
//       env: 'dev',
//       version: '1.0.0',
//       service: 'hikme_tst',
//       sessionSampleRate: 100,
//       sessionReplaySampleRate: 100,
//       compressIntakeRequests: false,
//       trackInteractions: true,
//       traceType: 'w3c_traceparent', // 非必填，默认为ddtrace，目前支持 ddtrace、zipkin、skywalking_v3、jaeger、zipkin_single_header、w3c_traceparent 6种类型
//       allowedTracingOrigins: [/.*/],  // 非必填，允许注入trace采集器所需header头部的所有请求列表。可以是请求的origin，也可以是是正则
//     });
//     datafluxRum.startSessionReplayRecording()
//   }
// }

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
